import { PROPERTIES_PAGE_LINK, SHARED_FILTER_RESULT_PAGE_LINK, SESSIONS_PAGE_LINK } from './links';
import { NavbarGroupItemTypes } from '../../types';
import { getProjectCode } from '../../utils/storage';

export const navigationConfig: NavbarGroupItemTypes[] = [
  {
    key: 'managements',
    title: 'navigation.management.title',
    type: 'group',
    children: [
      {
        key: 'real-estate-properties',
        title: 'navigation.management.properties-title',
        type: 'item',
        icon: 'icon-home_outline_24x24',
        url: PROPERTIES_PAGE_LINK.replace(':projectCode', getProjectCode()),
      },
      {
        key: 'real-estate-properties-shared-filter-result',
        title: 'navigation.management.shared-filter-result-title',
        type: 'item',
        icon: 'icon-share_outline_24x24',
        url: SHARED_FILTER_RESULT_PAGE_LINK,
      },
      {
        key: 'real-estate-session',
        title: 'navigation.management.session',
        type: 'item',
        icon: 'icon-money_24x24',
        url: SESSIONS_PAGE_LINK,
      },
    ],
  },
];
